import { DATA, META } from '@/plugins/vuex-async-pagginate';

const check_is_allow_direction_to_pbx = item => {
  const allow_statuses = ['direction_to_pbx_error'];
  const { state } = item;

  if (state) {
    return allow_statuses.includes(state);
  }

  return true;
};
export const PurchasedNumberFormatter = {
  formatItem: function(item) {
    const is_allow_direction_to_pbx = check_is_allow_direction_to_pbx(item);
    const formatNumber = Object.assign({}, item, { number: `+${parseInt(item.number)}` });

    return { ...formatNumber, is_allow_direction_to_pbx };
  },

  formatItems: function(items = []) {
    return items.map(item => PurchasedNumberFormatter.formatItem(item));
  },

  formatItemWithPaginate: function(response) {
    return {
      [META]: response[META],
      [DATA]: PurchasedNumberFormatter.formatItems(response[DATA])
    };
  }
};
